import script from "./ranking-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./ranking-chart.vue?vue&type=script&setup=true&lang=ts"

import "./ranking-chart.vue?vue&type=style&index=0&id=6e032d82&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e032d82"]])

export default __exports__